var _defs, _g, _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _g2, _line6, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperworkComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.004,
    height: 56.785,
    viewBox: "0 0 50.004 56.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6918",
    "data-name": "Rect\\xE1ngulo 6918",
    width: 50.004,
    height: 56.785,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17486",
    "data-name": "Grupo 17486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17485",
    "data-name": "Grupo 17485",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6917",
    "data-name": "Rect\\xE1ngulo 6917",
    width: 48.16,
    height: 13.975,
    transform: "translate(0.922 21.394)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19408",
    "data-name": "Trazado 19408",
    d: "M53.575,114.893h6.051V109.91H57.609v-2.07h-4.68v2.07H50.911v2.8",
    transform: "translate(-39.177 -82.985)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19409",
    "data-name": "Trazado 19409",
    d: "M111.643,112.08v-2.17h-2.018v-2.07h-4.68v2.07h-2.018v4.983h6.243",
    transform: "translate(-79.205 -82.985)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19410",
    "data-name": "Trazado 19410",
    d: "M163.659,111.8V109.91h-2.018v-2.07h-4.68v2.07h-2.018v4.983h6.151",
    transform: "translate(-119.233 -82.985)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1385",
    "data-name": "L\\xEDnea 1385",
    x2: 2.466,
    transform: "translate(4.739 24.904)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1386",
    "data-name": "L\\xEDnea 1386",
    x2: 2.466,
    transform: "translate(4.739 28.382)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1387",
    "data-name": "L\\xEDnea 1387",
    x2: 2.466,
    transform: "translate(4.739 31.859)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1388",
    "data-name": "L\\xEDnea 1388",
    y1: 7.439,
    transform: "translate(28.126 8.677)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1389",
    "data-name": "L\\xEDnea 1389",
    y1: 6.63,
    transform: "translate(34.877 11.401)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17488",
    "data-name": "Grupo 17488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17487",
    "data-name": "Grupo 17487",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1390",
    "data-name": "L\\xEDnea 1390",
    y1: 2.082,
    transform: "translate(28.126 1.992)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1391",
    "data-name": "L\\xEDnea 1391",
    y1: 13.725,
    transform: "translate(44.477 7.563)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17490",
    "data-name": "Grupo 17490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17489",
    "data-name": "Grupo 17489",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_463",
    "data-name": "Elipse 463",
    cx: 3.111,
    cy: 3.111,
    r: 3.111,
    transform: "translate(31.766 4.831)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_464",
    "data-name": "Elipse 464",
    cx: 3.111,
    cy: 3.111,
    r: 3.111,
    transform: "translate(41.365 0.922)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1392",
    "data-name": "L\\xEDnea 1392",
    y1: 7.439,
    transform: "translate(21.589 8.677)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1393",
    "data-name": "L\\xEDnea 1393",
    y1: 6.63,
    transform: "translate(14.838 11.401)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1394",
    "data-name": "L\\xEDnea 1394",
    y1: 2.082,
    transform: "translate(21.589 1.992)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1395",
    "data-name": "L\\xEDnea 1395",
    y1: 13.728,
    transform: "translate(5.238 7.563)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_465",
    "data-name": "Elipse 465",
    cx: 3.111,
    cy: 3.111,
    r: 3.111,
    transform: "translate(11.726 4.831)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_466",
    "data-name": "Elipse 466",
    cx: 3.111,
    cy: 3.111,
    r: 3.111,
    transform: "translate(2.127 0.922)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1396",
    "data-name": "L\\xEDnea 1396",
    y2: 7.439,
    transform: "translate(21.589 40.669)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1397",
    "data-name": "L\\xEDnea 1397",
    y2: 6.63,
    transform: "translate(14.838 38.754)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1398",
    "data-name": "L\\xEDnea 1398",
    y2: 2.082,
    transform: "translate(21.589 52.711)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1399",
    "data-name": "L\\xEDnea 1399",
    y2: 13.725,
    transform: "translate(5.238 35.497)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_467",
    "data-name": "Elipse 467",
    cx: 3.111,
    cy: 3.111,
    r: 3.111,
    transform: "translate(11.726 45.731)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_468",
    "data-name": "Elipse 468",
    cx: 3.111,
    cy: 3.111,
    r: 3.111,
    transform: "translate(2.127 49.64)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1400",
    "data-name": "L\\xEDnea 1400",
    y2: 7.439,
    transform: "translate(28.126 40.669)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1401",
    "data-name": "L\\xEDnea 1401",
    y2: 6.63,
    transform: "translate(34.877 38.754)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1402",
    "data-name": "L\\xEDnea 1402",
    y2: 2.082,
    transform: "translate(28.126 52.711)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1403",
    "data-name": "L\\xEDnea 1403",
    y2: 13.728,
    transform: "translate(44.477 35.494)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_469",
    "data-name": "Elipse 469",
    cx: 3.111,
    cy: 3.111,
    r: 3.111,
    transform: "translate(31.766 45.731)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_470",
    "data-name": "Elipse 470",
    cx: 3.111,
    cy: 3.111,
    r: 3.111,
    transform: "translate(41.365 49.64)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperworkComplete);
export default __webpack_public_path__ + "static/media/paperworkComplete.61a78626f3b774bb6dd357e38115c1c4.svg";
export { ForwardRef as ReactComponent };